import React from 'react';
import clsx from 'clsx';
import { ThreeDots } from 'react-loader-spinner';

import './CommonButton.scss';

export const BUTTON_STYLES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
};

const CommonButton = ({
  type = 'button',
  children,
  onClick,
  styleColor = BUTTON_STYLES.PRIMARY,
  maxWidth,
  disabled,
  className,
  tabIndex = '0',
  htmlFor,
  isStrokeIcon = false,
  isLoading,
  form,
  value,
  LeftIcon,
  onMouseEnter,
  onMouseLeave,
}) => {
  const style = { maxWidth };

  return (
    <button
      tabIndex={tabIndex}
      type={type}
      disabled={!!disabled || isLoading}
      form={form}
      value={value}
      className={clsx(
        'common-button',
        `common-button--${styleColor}`,
        isStrokeIcon && `common-button--stroke-icon`,
        className,
      )}
      onClick={onClick}
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      htmlFor={htmlFor}>
      {isLoading ? <ThreeDots height={15} width={40} /> : LeftIcon ?? null}
      {children}
    </button>
  );
};

export default CommonButton;
